module.exports = __webpack_public_path__ + "img/teams-very-small-folder.029f583b.svg";